/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */


import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { headeruspLinkSX } from '@/components/content/Header/styles/Headerusp';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, Container, Stack } from '@mui/material';

import { FC, useEffect, useState } from 'react';
import { HeaderUspBarRightLinks } from './HeaderUspBarRightLinks';
import { waitForElement } from '@/utils/waitForElementToLoad';

export const HeaderUspBar: FC<{ isMobile: boolean }> = ({ isMobile }) => {
    const [currentUsp, setCurrentUsp] = useState(0);
    const [headeUSPBlocks, setHeadeUSPBlocks] = useState<any[]>([]);

    useEffect(() => {
        waitForElement(".header-usps", 5000, "header").then(function () {
            if (isMobile) {
                const headerUSP = document.querySelector('.header-usps');
                if (headerUSP) {
                    const blocks = [...document.getElementsByClassName('usp-block')];
                    blocks.forEach((uspBlock: { classList: { add: (arg0: string) => void; }; }) => {
                        uspBlock.classList.add("header-usp-hide-mobile");
                    });
                    headerUSP.classList.remove("hide-mobile");
                    setHeadeUSPBlocks(blocks);
                    hideShowHeaderUSP(currentUsp, blocks);
                }
            }
        }).catch((error) => {
            console.debug("Error: ", error.message);
        });
    }, [isMobile, currentUsp]);

    function hideShowHeaderUSP(nextUsp: number, blocks = headeUSPBlocks) {
        if (!blocks.length) return;
        blocks.forEach((uspBlock: { classList: { add: (arg0: string) => void; remove: (arg0: string) => void; }; }) => {
            uspBlock.classList.add("header-usp-hide-mobile");
        });
        let newUsp = nextUsp;
        if (newUsp < 0) newUsp = blocks.length - 1;
        if (newUsp >= blocks.length) newUsp = 0;
        blocks[newUsp].classList.remove("header-usp-hide-mobile");
        setCurrentUsp(newUsp);
    }


	return (
		<Box bgcolor='#fff' alignItems="center">
			<Container>
				<Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
					{isMobile && currentUsp !== 0 && (
						<ArrowBackIosIcon sx={{position:'absolute', left:8}} fontSize='small' onClick={() => hideShowHeaderUSP(currentUsp - 1)} />
					)}
					<Stack direction="row" sx={headeruspLinkSX}>  
                        <ContentRecommendation
                            id='IT-Header-USP-eSpot_rv'
                            properties={{ 'emsName': 'IT-Header-USP-eSpot_rv', width: '100%' }}
                        />
					</Stack>
					{isMobile && (
						<ArrowForwardIosIcon sx={{position:'absolute', right:4}} fontSize='small' onClick={() => hideShowHeaderUSP(currentUsp + 1)} />
					)}
					{!isMobile && <HeaderUspBarRightLinks {...{ isMobile }} />}
				</Stack>
			</Container>    
		</Box>
	);
};